import './Main.css';
import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import { AutoLock } from './AutoLock'
import { ChangeMic } from './ChangeMic'
import { ChangeNumberManager } from './ChangeNumberManager'
import { ChangePassword } from './ChangePassword'
import { ChildLock } from './ChildLock'
import { ChoiceDevice } from './ChoiceDevice'
import CustomModal from './CustomModal'
import { Education } from './Education'
import { Fabric } from './Fabric'
import { Internet } from './Internet'
import { Language } from './Language'
import { MenuBottom } from "./MenuBottom";
import { ModeAlert } from './ModeAlert'
import { NewDevice } from './NewDevice'
import { NewUser } from './NewUser'
import { PermitionListen } from './PermitionListen'
import { Repair } from './Repair'
import { toast } from "react-toastify";
import { version } from "../config.json";

export class Main extends Component {
    static displayName = Main.name;
    state = {
        progress: false,
        showModalNewDevice: false,
        showModalChoiceDevice: false,
        showModalSpeed: false,
        showModalLanguage: false,
        showModalNewUser: false,
        showModalChangeNumberManager: false,
        showModalChangePassword: false,
        showModalChangeMic: false,
        showModalPermitionListen: false,
        showModalModeAlert: false,
        showModalFabric: false,
        showModalAutoLock: false,
        showModalInternet: false,
        showModalRepair: false,
        showModalEducation: false,

        choiceDevice: {},

        speedChoice: 30,

        list: [],
    };


    checkVersion = (name)=>{        
        console.log(`${name} v${version} 😎`)
        const last_version = localStorage.getItem(`${name}-Version`);
        
        if(last_version !== version){
            console.log('New Version Available ! 😝')
            localStorage.setItem(`${name}-Version`, version)
            window.location.reload(true);
        }
    }

    componentDidMount() {
        this.checkVersion("Car");
        document.body.classList.add('bodyBackGround');
        this.getCard();
        this.loadChoiceDevice();
    }

    loadChoiceDevice = () => {
        let choice = cardService.getChoiceCard();
        this.setState({ choiceDevice: choice });
    }

    getCard = () => {
        let card = cardService.getCard();

        let choice = cardService.getChoiceCard();
        if (choice != []) {
            let article = card.find(m => m.deviceNumber === choice.deviceNumber);
            if (article) {
                //console.log('find2',article);
                article.ch = true;
            }
        }
        this.setState({ list: card });
        //console.log('dd',card); 
    }

    closeModalNewDevice = (e) => {
        e.preventDefault();
        this.setState({ showModalNewDevice: false });
        this.getCard();
    }

    closeModalChoiceDevice = (e) => {
        e.preventDefault();
        this.setState({ showModalChoiceDevice: false });
        this.loadChoiceDevice();
    }


    onClickMenuLeft = (id) => {
        if (id == 4)
            this.setState({ showModalNewDevice: true });
        else if (id == 5)
            this.setState({ showModalNewUser: true });
        else if (id == 1)
            this.setState({ showModalChoiceDevice: true });
        else if (id == 6)
            this.setState({ showModalChangeNumberManager: true });
        else if (id == 8)
            this.setState({ showModalChangePassword: true });
        else if (id == 9)
            this.setState({ showModalChangeMic: true });
        else if (id == 10)
            this.setState({ showModalPermitionListen: true });
        else if (id == 11)
            this.setState({ showModalModeAlert: true });
        else if (id == 12)
            this.setState({ showModalChildLock: true });
        else if (id == 13)
            this.setState({ showModalFabric: true });
        else if (id == 14)
            this.setState({ showModalAutoLock: true });
        else if (id == 16)
            this.setState({ showModalInternet: true });
        else if (id == 17)
            this.setState({ showModalRepair: true });
        else if (id == 18)
            this.setState({ showModalEducation: true });



        else if (id == 2) {
            document.location = 'http://www.gpsnoroncar.com/index.php';
            return;
        }
        else if (id == 3) {
            document.location = 'http://gpsnoron.ir/index.php';
            return;
        }
        else if (id == 18) {
            document.location = 'http://noroncar.ir/%DA%A9%D8%B3%D8%A8-%D8%AF%D8%B1%D8%A2%D9%85%D8%AF/';
            return;
        }
        else if (id == 19) {
            document.location = 'https://web.noron1.ir';
            return;
        }
    }

    itemChoice = (e, item) => {
        //const link = document.createElement('a');
        //let sms = `sms:${this.state.choiceDevice.deviceNumber}?body=`;
        if (item == "itemLocation")
            utils.sendSms(this.state.choiceDevice.deviceNumber, "loc");
        //link.href = `${sms}loc`;
        else if (item == "itemSpeedControl")
            utils.sendSms(this.state.choiceDevice.deviceNumber, `vel,${this.state.speedChoice}`);
        //link.href = `${sms}vel,${this.state.speedChoice}`;
        else if (item == "itemGeoArea") {
            this.props.history.push({ pathname: '/geoArea' });
            return;
        } else if (item == "itemVoice") {
            const link = document.createElement('a');
            let temp = utils.checkNumber(this.state.choiceDevice.deviceNumber);
            link.href = `tel:+${temp}`;
            document.body.appendChild(link);
            link.click();
            return;
        } else if (item == "itemEducation") {
            document.location = 'http://noroncar.ir/instruction/amozsh';
            return; 
        } else if (item == "itemState")
            utils.sendSms(this.state.choiceDevice.deviceNumber, `report`);
        //link.href = `${sms}report`;
        else if (item == "itemStopCar") {
            this.props.history.replace({ pathname: '/carStop' });
            return;
        }
        else if (item == "itemControl") {
            this.props.history.replace({ pathname: '/control' });
            return;
        }
        else
            return;

        //link.setAttribute('download', 'file.pdf');
        //document.body.appendChild(link);
        //link.click();
        toast.dark('لطفا تا دریافت پیامک از دستگاه صبر کنید ...');
    }

    speedModal = () => {
        let items = [];
        for (let i = 30; i < 150; i++)
            items.push(<li key={"i" + i}
                className={"list-group-item " + (this.state.speedChoice == i ? "list-group-item-dark" : "list-group-item-light")}
                onClick={(e) => this.setState({ speedChoice: i })}
            >
                <div className="d-flex justify-content-center">
                    {i}
                </div>
            </li>);

        return (
            <CustomModal show={this.state.showModalSpeed} onClose={(e) => { this.setState({ showModalSpeed: false }) }} >
                <div className="row">
                    <div className="col">
                        <div className="d-flex justify-content-center">
                            لطفا مقدار مورد نظر را انتخاب بفرمایید
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <ul className="list-group" id="speedGroup">
                            {items}
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className=" d-flex justify-content-center" >
                            <a onClick={(e) => {
                                e.preventDefault();
                                this.itemChoice(e, "itemSpeedControl");
                                this.setState({ showModalSpeed: false });
                            }}>
                                <img src="images/accept.svg" className="imgButtonModal"></img>
                            </a>
                            <a onClick={(e) => { this.setState({ showModalSpeed: false }) }}>
                                <img src="images/cancel.svg" className="imgButtonModal"></img>
                            </a>
                        </div>
                    </div>
                </div>
            </CustomModal>
        )
    }




    render() {
        return (
            <>
                <NewDevice showModal={this.state.showModalNewDevice} closeModal={(e) => this.closeModalNewDevice(e)} />
                <NewUser showModal={this.state.showModalNewUser} closeModal={(e) => { this.setState({ showModalNewUser: false }) }} />
                <ChoiceDevice setList={(list) => this.setState({ list: list })} list={this.state.list} showModal={this.state.showModalChoiceDevice} closeModal={(e) => this.closeModalChoiceDevice(e)} />
                <Language showModal={this.state.showModalLanguage} closeModal={(e) => this.setState({ showModalLanguage: false })} />
                <ChangeNumberManager showModal={this.state.showModalChangeNumberManager} closeModal={(e) => this.setState({ showModalChangeNumberManager: false })} />
                <ChangePassword showModal={this.state.showModalChangePassword} closeModal={(e) => this.setState({ showModalChangePassword: false })} />
                <ChangeMic showModal={this.state.showModalChangeMic} closeModal={(e) => this.setState({ showModalChangeMic: false })} />
                <PermitionListen showModal={this.state.showModalPermitionListen} closeModal={(e) => this.setState({ showModalPermitionListen: false })} />
                <ModeAlert showModal={this.state.showModalModeAlert} closeModal={(e) => this.setState({ showModalModeAlert: false })} />
                <ChildLock showModal={this.state.showModalChildLock} closeModal={(e) => this.setState({ showModalChildLock: false })} />
                <Fabric showModal={this.state.showModalFabric} closeModal={(e) => this.setState({ showModalFabric: false })} />
                <AutoLock showModal={this.state.showModalAutoLock} closeModal={(e) => this.setState({ showModalAutoLock: false })} />
                <Internet showModal={this.state.showModalInternet} closeModal={(e) => this.setState({ showModalInternet: false })} />
                <Repair showModal={this.state.showModalRepair} closeModal={(e) => this.setState({ showModalRepair: false })} />
                <Education showModal={this.state.showModalEducation} closeModal={(e) => this.setState({ showModalEducation: false })} />


                {this.speedModal()}


                <div className="container">
                    <div className="row" id="rowTop">
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <div className="titleName">
                                        <span id="deviceNameCaption">دستگاه :</span><span id="deviceName">{this.state.choiceDevice.deviceName}</span>
                                    </div>
                                    <div className="titleSim">
                                        <span id="simNameCaption">سیم کارت :</span><span id="simName">{this.state.choiceDevice.deviceNumber}</span>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <img src="/images/logoTop.svg" id="logoTop" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <div className="container" id="rowMenu">
                    <div className="row">
                        <div className="col">
                            <div className="MainMenuItem" id="itemLocation" onClick={(e) => this.itemChoice(e, "itemLocation")}>
                                <img src="/images/Location.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">موقعیت یابی</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="MainMenuItem" id="itemSpeedControl" onClick={(e) => this.setState({ showModalSpeed: true })}>
                                <img src="/images/SpeedControl.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">کنترل سرعت</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="MainMenuItem" id="itemGeoArea" onClick={(e) => this.itemChoice(e, "itemGeoArea")}>
                                <img src="/images/GeoArea.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">حصار جغرافیایی</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <div className="MainMenuItem" id="itemVoice" onClick={(e) => this.itemChoice(e, "itemVoice")}>
                                <img src="/images/Voice.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">شنود صدا</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="MainMenuItem" id="itemState" onClick={(e) => this.itemChoice(e, "itemState")}>
                                <img src="/images/state.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">وضعیت</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="MainMenuItem" id="itemStopCar" onClick={(e) => this.itemChoice(e, "itemStopCar")}>
                                <img src="/images/StopCar.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">توقف خودرو</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="MainMenuItem" id="itemWebNoron" onClick={(e) => this.onClickMenuLeft(19)}>
                                <img src="/images/Education.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">سامانه نورون</p>
                            </div>
                        </div>
                        
                         <div className="col">
                            <div className="MainMenuItem" id="itemRegion" onClick={(e) => this.onClickMenuLeft(1)} >
                                <img src="/images/region.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">انتخاب خودرو</p>
                            </div>
                        </div>{/*
                        <div className="col">
                            <div className="MainMenuItem" id="itemEducation" onClick={(e) => this.onClickMenuLeft(18)}>
                                <img src="/images/Education.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">آموزش</p>
                            </div>
                        </div>*/}{/*onClick={(e) => this.itemChoice(e, "itemEducation")}*/}
                        <div className="col">
                            <div className="MainMenuItem" id="itemControl" onClick={(e) => this.itemChoice(e, "itemControl")}>
                                <img src="/images/Control.svg" className="imgMainMenu" />
                                <p className="itemMainMenu">کنترل دزدگیر</p>
                            </div>
                        </div>
                    </div>
                </div>
                <MenuBottom ClickMenu={this.onClickMenuLeft} />
            </>
        );
    }

}